export enum eTipoPesquisaFiltroEstudantes {
    Todos = "Todos",
}

export class ModalFiltroEstudantesParams {
    eTipoPesquisaFiltroEstudantes: eTipoPesquisaFiltroEstudantes = eTipoPesquisaFiltroEstudantes.Todos;
    route: string = '';
}